module.exports = __webpack_public_path__ + "img/download_ios.14d39fb8.png";